/* General functions for datalayer*/

if (!SSR_MODE) {
  if (typeof(window) !== 'undefined' && !window.dataLayer) {
    window.dataLayer = []
    window.dataLayer['push'] = function (v) {
      console.log('MOCKED dataLayer: ', v)
    }
  }
}

export default {
  add: function (ev) {
    if (SSR_MODE) {return}

    window.dataLayer.push(ev)
  }
}
